<div class="chartDesign">
  <div class="chartDesign" *ngIf="isIsoReport">
    <p class="content-figure uniqFigureSeq">
      {{ reportResource.lblAllLifeCycle }} - {{ scenarioName }} is shown in figure #1.
    </p>
  </div>
  <br />
  <ng-container *ngIf="isIsoReport">
    <br />
  </ng-container>

  <div>
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      style="width: 100%; height: 800px; display: block"
    ></highcharts-chart>
  </div>
</div>
